import React, { useEffect, useState } from "react";
import { Button, Container, Modal, Spinner, Table } from "react-bootstrap";
import {
  Autocomplete,
  createFilterOptions,
  TextField,
  Typography,
} from "@mui/material";
import TableContent from "../../table/table";
import Loader from "../../../loader/loader";
import { useDispatch, useSelector } from "react-redux";
import notify from "../../../Notifcation";
import {
  CreateAgencyDestinationAction,
  UpdateAgencyDestinationAction,
} from "../../../../redux/actions/AgencyDestinationAction";
import { ToastContainer } from "react-toastify";
import {
  AddCourtAction,
  AddLocTypeAction,
  AddLocnumberAction,
  DeleteLocTypeAction,
  GetCourtAction,
  GetLocTypeAction,
  GetLocnumberAction,
  UpdateLocTypeAction,
} from "../../../../redux/actions/CourtAction";
const filter = createFilterOptions();

const CircleType = () => {
  const [TypeCirclee, setTypeCirclee] = useState("");
  const [DescTypecircle, setDescTypecircle] = useState("");
  const [Mahkamaa, setMahkama] = useState("");

  const [Note, setNote] = useState("");
  const [IDcircleType, setIDcircleType] = useState("");
  const [Eye, setEye] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isPress, setIsPress] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [showDelete, setshowDelete] = useState(false);
  const handleCloseDelete = () => setshowDelete(false);
  const handleShoweDelete = (itemid) => {
    setshowDelete(true);
    setIDcircleType(itemid);
  };
  const ALLa = useSelector((state) => state.CourtR.Courts);

  useEffect(() => {
    dispatch(GetCourtAction());
  }, []);
  const handelDeleteItem = async () => {
    setIsPress(true);
    setLoading(true);
    await dispatch(DeleteLocTypeAction(IDcircleType));
    setLoading(false);
    setIDcircleType("");
    setshowDelete(false);
    setIsPress(false);
  };
  const ALL = useSelector((state) => state.CourtR.Loctype);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(GetLocTypeAction());
  }, []);
  const handlesubmit = async (e) => {
    e.preventDefault();
    if (TypeCirclee === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setIsPress(true);
    setLoading(true);
    await dispatch(
      AddLocTypeAction({
        Type: TypeCirclee,
        CourtId: Mahkamaa?.Id,
        Description: DescTypecircle,
        Note: Note,
      })
    );
    setTypeCirclee("");
    setNote("");
    setDescTypecircle("");
    setIDcircleType("");
    setIsPress(false);
    setLoading(false);
  };
  const handleUpdate = async (e) => {
    e.preventDefault();
    if (TypeCirclee === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setIsPress(true);
    setLoading(true);
    await dispatch(
      UpdateLocTypeAction({
        Id: IDcircleType,
        Type: TypeCirclee,
        CourtId: Mahkamaa?.Id,
        Description: DescTypecircle,
        Note: Note,
        Courtname: Mahkamaa?.Name,
      })
    );
    setTypeCirclee("");
    setNote("");
    setDescTypecircle("");
    setIDcircleType("");
    setIsPress(false);

    setLoading(false);
  };
  const Update = (item) => {
    setTypeCirclee(item.Type);
    setNote(item.Note);
    setIDcircleType(item.Id);
    setDescTypecircle(item.Description);
    setMahkama({ Id: item.CourtId, Name: item.Courtname });
    setIsEdit(true);
    setEye(false);
  };
  const HandleEye = (item) => {
    setTypeCirclee(item.Type);
    setNote(item.Note);
    //setIDcircleType(item.Id);
    setDescTypecircle(item.Description);
    setMahkama({ Id: item.CourtId, Name: item.Courtname });
    setIsEdit(false);
    setEye(true);
  };
  const res = useSelector((state) => state.CourtR.AddLoctype);
  const UP = useSelector((state) => state.CourtR.UpdateLoctype);
  const DEL = useSelector((state) => state.CourtR.DeleteLoctype);
  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 2000);
      if (res) {
        if (res.status === 200 || res.status === 201) {
          if (
            res.data &&
            res.data.ResponseMessage ===
              "Great, Location type created successfully"
          ) {
            dispatch(GetLocTypeAction());
            dispatch(GetCourtAction());
            notify("تم اضافة البيانات بنجاح", "success");
          }
        } else if (res.status !== 200 || res.status !== 201) {
          // if (res.data && res.data.responseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
      if (UP) {
        if (UP.data.StatusCode === 200 || UP.data.StatusCode === 201) {
          if (
            UP.data &&
            UP.data.ResponseMessage ===
              "Great, location type updated Successfully"
          ) {
            dispatch(GetLocTypeAction());
            dispatch(GetCourtAction());
            notify("تم تحديث البيانات بنجاح", "success");
          }
        } else if (UP.StatusCode !== 200 || UP.StatusCode !== 201) {
          // if (res.data && res.data.ResponseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }

      if (DEL) {
        if (DEL.StatusCode === 200 || DEL.StatusCode === 201) {
          if (
            DEL &&
            DEL.ResponseMessage === "Great, Location Type deleted Successfully"
          ) {
            dispatch(GetLocTypeAction());
            dispatch(GetCourtAction());
            notify("تم حذف نوع الدائرة بنجاح", "success");
          }
        } else if (DEL.StatusCode !== 200 || DEL.StatusCode !== 201) {
          if (
            DEL &&
            DEL.ResponseMessage === "can't delete this because you are using it"
          ) {
            notify("لا يمكن حذف هذة المحكمة لانها مستخدمة", "warn");
          } else notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
    }
  }, [loading]);
  return (
    <>
      <div className="enterr">
        <Container>
          <div className="inputs-container">
            <div className="inp-container">
              <Autocomplete
                value={Mahkamaa}
                onChange={(event, newValue) => {
                  if (typeof newValue === "string") {
                    setMahkama({
                      name: newValue,
                    });
                  } else if (newValue && newValue.inputValue) {
                    // Create a new value from the user input
                    setMahkama({
                      name: newValue.inputValue,
                    });
                  } else {
                    setMahkama(newValue);
                  }
                }}
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);

                  const { inputValue } = params;
                  // Suggest the creation of a new value
                  const isExisting = options.some(
                    (option) => inputValue === option.name
                  );
                  if (inputValue !== "" && !isExisting) {
                    filtered.push({
                      inputValue,
                      // title: `لا توجد حسابات بهذا الاسم"${inputValue}"`,
                    });
                  }

                  return filtered;
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                id="free-solo-with-text-demo"
                options={ALLa && ALLa.length > 0 ? ALLa : []}
                getOptionLabel={(option) => {
                  // Value selected with enter, right from the input
                  if (typeof option === "string") {
                    return option;
                  }
                  // Add "xxx" option created dynamically
                  if (option.inputValue) {
                    return option.inputValue;
                  }
                  // Regular option
                  return option.Name;
                }}
                renderOption={(props, option) => (
                  <li {...props}>{option.Name}</li>
                )}
                sx={{ width: 300 }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        المحكمة
                        <span style={{ color: "red", fontSize: "21px" }}>
                          *
                        </span>
                      </Typography>
                    }
                  />
                )}
              />
            </div>
            <div className="inp-container">
              <TextField
                inputProps={{ maxLength: 120 }}
                type="text"
                value={TypeCirclee}
                onChange={(e) => setTypeCirclee(e.target.value)}
                label={
                  <Typography sx={{ fontSize: "17", fontFamily: "Almarai" }}>
                    نوع الدائرة
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                //   className="ww"
              />
            </div>
            <div className="inp-container">
              <TextField
                inputProps={{ maxLength: 120 }}
                type="text"
                value={DescTypecircle}
                onChange={(e) => setDescTypecircle(e.target.value)}
                label={"الوصف"}
                variant="outlined"
                //   className="ww"
              />
            </div>
            <div className="inp-container">
              <TextField
                value={Note}
                onChange={(e) => setNote(e.target.value)}
                label="ملاحظات"
                inputProps={{ maxLength: 120 }}
                type="text"
                variant="outlined"
                //   className="ww"
              />
            </div>
            <div className="inp-container"></div>
            <div className="inp-container"></div>
          </div>
          {Eye ? null : (
            <>
              {isEdit ? (
                <>
                  {loading && isPress ? (
                    <button className="buttonadd">
                      <Spinner />
                    </button>
                  ) : (
                    <button className="buttonadd" onClick={handleUpdate}>
                      تعديل
                    </button>
                  )}
                </>
              ) : (
                <>
                  {loading && isPress ? (
                    <button className="buttonadd">
                      <Spinner />
                    </button>
                  ) : (
                    <button className="buttonadd" onClick={handlesubmit}>
                      إضافة
                    </button>
                  )}
                </>
              )}
            </>
          )}
          {/* <div className="inputs-container">
            <div className="inp-container ">
              {" "}
              <TextField
                
                label="ابحث"
                variant="outlined"
                //   className="ww"
              />
              <i className="ty fa-solid fa-magnifying-glass"></i>
            </div>{" "}
            <div className="inp-container"></div>
            <div className="inp-container"></div>
          </div> */}
        </Container>{" "}
        <Table
          id="my-table"
          className="maint"
          responsive
          striped
          bordered
          hover>
          <thead>
            <tr>
              <th>
                نوع الدائرة<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                المحكمة <i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                الوصف <i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                ملاحظات <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(ALL) && ALL.length > 0
              ? ALL.map((item) => (
                  <tr key={item.Id} onDoubleClick={() => Update(item)}>
                    <td>{item.Type}</td>
                    <td>{item.Courtname}</td>
                    <td>{item.Description}</td>
                    <td>{item.Note}</td>
                    <td className="icon-w" onClick={() => Update(item)}>
                      <i
                        className="fa fa-solid fa-pen-to-square icon-blue"
                        style={{ color: "#333" }}></i>
                    </td>
                    <td className="icon-w">
                      {" "}
                      <i
                        onClick={() => handleShoweDelete(item.Id)}
                        className="fs fa-solid fa-trash-can icon-red"
                        style={{ color: "#333" }}></i>
                    </td>
                    <td className="icon-w">
                      <i
                        onClick={() => HandleEye(item)}
                        className="fa-solid fa-eye"
                        style={{ color: "#333" }}></i>
                    </td>
                  </tr>
                ))
              : null}
          </tbody>
        </Table>
      </div>
      <ToastContainer autoClose={1200} />
      <div className="mod">
        <Modal
          show={showDelete}
          onHide={handleCloseDelete}
          backdrop="static"
          centered
          contentClassName="cont"
          keyboard={false}
          style={{ width: "100%", margin: "0px auto", textAlign: "center" }}>
          {/* <Modal.Header closeButton>
          <Modal.Title> </Modal.Title>
        </Modal.Header> */}
          <Modal.Body>هل تريد الحذف ؟ </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="close"
              onClick={handleCloseDelete}>
              إغلاق
            </Button>
            <Button
              variant="primary"
              className="edit"
              onClick={handelDeleteItem}>
              موافق
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default CircleType;
